import { useEffect } from 'react';
import { AppState, AppStateStatus } from 'react-native';

import { useMarketCacheStore } from '@/feature/event-details-sbk/hooks/use-market-cache';
import { useMicroMarketCacheStore } from '@/feature/event-details-sbk/hooks/use-micro-market-cache';
import { useIsSweepsOrPredictionsProduct } from '@/hooks/use-is-sweeps-or-predictions-product';
import { useEventDetailsCache } from '@/hooks/use-sbk-event-details-cache';

import { useJurisdictionStore } from './use-jurisdiction';

/**
 * Clears the market cache when the app goes to the background to prevent cache from growing too large and being stale
 */
export const useClearMarketCache = () => {
    const clearMarketCache = useMarketCacheStore(state => state.actions.clear);
    const product = useJurisdictionStore(state => state.product);
    const clearMicroMarketCache = useMicroMarketCacheStore(state => state.actions.clearCache);
    const clearEventDetailsCache = useEventDetailsCache(state => state.actions.clear);
    const isSweepsOrPredictions = useIsSweepsOrPredictionsProduct();

    useEffect(() => {
        clearMarketCache();
        clearMicroMarketCache();
        clearEventDetailsCache();
    }, [product, clearMarketCache, clearMicroMarketCache, clearEventDetailsCache]);

    useEffect(() => {
        if (isSweepsOrPredictions) {
            const handleAppStateChange = (nextAppState: AppStateStatus) => {
                if (nextAppState === 'background') {
                    clearMarketCache();
                }
            };
            const subscription = AppState.addEventListener('change', handleAppStateChange);

            return () => {
                subscription.remove();
            };
        }
    }, [isSweepsOrPredictions, clearMarketCache]);
};
